import React from 'react';
function CellHeader({ fcProps }) {
    return React.createElement("span", { className: "cal__num" }, fcProps.dayNumberText);
}
export default CellHeader;
